import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_BUM = gql`
    query getAllEstadoBUM{
        allEstadoCondicionalBUM
        {
            idEstadoCondicionalBUM,
            descripcion,
            codigo
        }
 }
`;